// Numeric Apple ID from App Store Connect → App Information. iOS only:
// on Android the store resolves the package name from the app context.
export const APP_STORE_ID = "6761166656"

export const RUSTORE_APP_URL =
	"https://www.rustore.ru/catalog/app/com.luni.monster"

export const APP_STORE_URL = `https://apps.apple.com/app/id${APP_STORE_ID}`

export const GOOGLE_PLAY_URL =
	"https://play.google.com/store/apps/details?id=com.luni.monster"
